import React, { Component } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import withLocaleContext from '../../../hoc/withLocaleContext';
import { getProviderPayment } from '../../../services/Api';
import RedirectNotification from '../notification/RedirectNotification';

export interface providerResponse {
  redirectUrl: string;
}

class RedirectScreen extends Component<
  RouteComponentProps<{ paymentId: string; type: string }> & Partial<ILocaleContext>
> {
  async componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const locale = urlParams.get('locale');
    const token = urlParams.get('token');

    const {
      match: {
        params: { paymentId },
      },
      setLocaleFromPaymentRequest,
    } = this.props;

    if (setLocaleFromPaymentRequest) {
      setLocaleFromPaymentRequest(locale);
    }

    if (!token || !paymentId) {
      this.setState(() => {
        throw new Error('No token or payment id');
      });
      return;
    }
    const redirectToProviderUrl = async () => {
      try {
        const providerUrlResponse: providerResponse = await getProviderPayment(paymentId, `${token}`);
        setTimeout(() => {
          window.location.assign(providerUrlResponse.redirectUrl);
        }, 2000);
      } catch (e) {
        this.setState(() => {
          throw e;
        });
      }
    };

    setTimeout(() => {
      redirectToProviderUrl();
    }, 2000);
  }

  render() {
    const {
      match: {
        params: { type },
      },
    } = this.props;
    return <RedirectNotification type={type} />;
  }
}

export default withLocaleContext(withRouter(RedirectScreen));
